var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSomethingWentWrong(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 164,
    viewBox: "0 0 164 164",
    width: 164,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.83301 82c0-41.5129 33.65379-75.16669 75.16669-75.16669 41.5073 0 75.1663 33.65379 75.1663 75.16669 0 41.513-33.653 75.167-75.1663 75.167-41.5129 0-75.16669-33.654-75.16669-75.167z",
    fill: "#d32f2f"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m50.1395 58.1398c-1.7867 1.7867-1.7867 4.6835 0 6.4703l2.3109 2.3108-2.3108 2.3108c-1.7868 1.7868-1.7868 4.6836 0 6.4704 1.7867 1.7867 4.6835 1.7867 6.4703 0l2.3108-2.3109 2.3108 2.3108c1.7867 1.7868 4.6836 1.7868 6.4703 0 1.7867-1.7867 1.7867-4.6836 0-6.4703l-2.3108-2.3108 2.3108-2.3108c1.7868-1.7867 1.7868-4.6836 0-6.4703-1.7867-1.7868-4.6836-1.7868-6.4703 0l-2.3108 2.3108-2.3108-2.3108c-1.7868-1.7868-4.6836-1.7868-6.4704 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m96.746 57.6372c-1.7868 1.7867-1.7868 4.6836 0 6.4703l2.3108 2.3108-2.3108 2.3108c-1.7868 1.7868-1.7868 4.6836 0 6.4703 1.7867 1.7868 4.684 1.7868 6.47.0001l2.311-2.3109 2.311 2.3109c1.787 1.7867 4.684 1.7867 6.47 0 1.787-1.7867 1.787-4.6836 0-6.4703l-2.311-2.3109 2.311-2.3108c1.787-1.7867 1.787-4.6836 0-6.4703-1.786-1.7868-4.683-1.7868-6.47 0l-2.311 2.3108-2.311-2.3108c-1.786-1.7867-4.6833-1.7867-6.47 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 16,
    rx: 8,
    width: 64,
    x: 50,
    y: 98
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSomethingWentWrong);
export default __webpack_public_path__ + "static/media/somethingWentWrong.2d48b2193e251b88154289c93e52eeb4.svg";
export { ForwardRef as ReactComponent };